import React, { useEffect, useState } from "react";
import styles from './style.module.css'
import Form from "../../../Component/CampusDrive/invitation/form";
import { Link, useParams } from "react-router-dom/cjs/react-router-dom.min";
import logo from '../../../assets/images/logo.png'
import SupportIcon from '../../../assets/images/icon/SupportIcons.svg'
import { toast } from "react-toastify";
import { jobDriveRegistration } from "../../../action/campusDrive";
import Swal from "sweetalert2";
const JobPost = () => {

    const { slug } = useParams();
    const [collegeDetail, setCollegeDetail] = useState("");

    useEffect(() => {
        if (slug) {
            try {
                const decoded = JSON.parse(atob(slug));
                setCollegeDetail(decoded);
            } catch (err) {
                console.log("Invalid slug");
            }
        }
    }, [slug]);

    const onSubmit = (payload) => {

        jobDriveRegistration({
            slug,
            ...payload
        }).then(res => {

            if (res.status) {

                Swal.fire({
                    icon: "success",
                    title: "Registration Submitted",
                    text: "Thank you for registering for the Job Drive.",
                    confirmButtonText: "Go to Home"
                }).then(() => {

                    window.location.href = "/";

                });
            } else {

                toast.error(res.message || "Something went wrong");

            }

        });

    };

    return (

        <React.Fragment>

            <div className='container-fluid mt-3'>

                <div className='row'>

                    <div className='col-md-12'>

                        <div className={`${styles['jobheader-box']}`}>

                            <div className="navbar-brand logo">
                                <Link to='/'><img src={logo} alt="logo" /></Link>
                            </div>

                            <div className={`${styles['jobheader-list']}`}>
                                <a
                                    target='_blank'
                                    href="https://api.whatsapp.com/send/?phone=+917353466466&text=Need+help+in+job+posting.&type=phone_number&app_absent=0"
                                >
                                    <img src={SupportIcon} alt="SupportIcon" className='pe-2' />
                                    Get instant Support
                                </a>
                            </div>

                        </div>

                    </div>

                </div>

                <div className="my-3 p-2 row">

                    <div className="col-md-12">

                        <div className="card border-0 shadow-ctm bg-light rounded-3">

                            <div className="card-body">

                                <div className="row">

                                    <div className="col-md-12">

                                        <div className={`${styles['post-box']} mb-4 mt-3`}>

                                            <h2 className={`${styles['post-title']}`}>
                                                Job Drive Registration
                                            </h2>

                                            <p className="mb-0">
                                                <span className={`${styles['span-title']}`}>for</span>
                                                <span className={`${styles['sub-title']}`}>
                                                    {collegeDetail?.collegeName || '--'}
                                                </span>
                                            </p>

                                        </div>

                                        <div className={`${styles['inner-post']}`}>

                                            <div className={`${styles['box-inner']}`}>

                                                <div className="card shadow-ctm border-0 rounded-3">

                                                    <div className="card-body">

                                                        <Form
                                                            styles={styles}
                                                            onSubmit={onSubmit}
                                                        />

                                                    </div>

                                                </div>

                                            </div>

                                        </div>

                                    </div>

                                </div>

                            </div>

                        </div>

                    </div>

                </div>

            </div>

        </React.Fragment>

    )

}

export default JobPost;